import React, { useState } from "react";
import Header from "../Component/Header";
import Breadcrumb from "../Component/Breadcrumb";
import Footer from "../Component/Footer";
import LazyLoad from "react-lazyload";
import FormAdmissionClassXI from "../Component/FormAdmissionClassXI";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";
const AdmissionProcedure = () => {
  const [showFormXI, setShowFormXI] = useState(false);
  const handleOpenFormXI = () => setShowFormXI(true);
  const handleCloseFormXI = () => setShowFormXI(false);
   const { state } = useLocation();
   console.log("what is info",state)
  const grade = state?.grade;
  const info = state?.info

  console.log("Selected Grade:", grade);
  console.log("Selected Info:", info);


  return (
    <>
      <Header />
      {showFormXI && <FormAdmissionClassXI onClose={handleCloseFormXI} />}
      <Breadcrumb
        title="Admission Procedure"
        mid="Academic &nbsp; &nbsp;|"
        tabName="Admission Procedure"
      />
      <div className="innerPage admission-procedure">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <Link to='/admission-classxi'> 
              {/* <button className="handleOpenFormXI" onClick={handleOpenFormXI}> */}
              <button className="handleOpenFormXI" >
                Admission For Class XI
              </button> </Link>
            </div>
          <h2 style={{ marginTop: "20px" }}>
  <marquee
    behavior="scroll"
    direction="left"
    scrollamount="8"
    style={{
      color: "#d17b00",
      backgroundColor: "#fff4e5",
      padding: "10px",
      borderRadius: "8px",
      fontWeight: "600",
      border: "1px solid #f5c27a"
    }}
  >
    Admissions for {grade} {info?.length >0 ? info : "are currently unavailable. Please check back later." } 
  </marquee>
</h2>
             <div className="col-md-8">
              <h3>
                Admission to <span>Holy Spirit Pre-Primary School</span>
              </h3>
              <ul className="list-view">
                <li>
                  
                  Admission to this School is restricted by condition of age,
                  ability and conduct. Applicants for admission will be
                  carefully selected.
                </li>
                <li>
                  
                  The age criteria for Nursery Class is between 3 to 4
                  years.
                </li>
                <li>
                  For all the admissions to kindergarten classes ORIGINAL birth
                  certificate with a photostat copy of Birth Certificate duly
                  attested should be produced in the office. (Original birth
                  certificate is returned to the parents after verification of
                  the documents). At the time of admission, the students should
                  be introduced personally by their parents/guardian who will be
                  responsible for their studies, fees, conduct and
                  discipline.
                </li>
                <li>
                  The Principal/Head Mistress reserves to herself the right of
                  admission.
                </li>
                <li>
                  For more information on admission kindly contact the school
                  office.
                </li>
              </ul>

              <h3>NURSERY FORMS for Session 2027-2028</h3>
              <p>
                NURSERY CLASS Registration form will be available ONLINE on
                School website and on below mentioned campuscare10x link.
              </p>
              <p>
                <b>ONLINE REGISTRATION FORM will be available from:</b>
              </p>

              <p>
                <b>
                  23rd November 2026 at 10 am till 30th November 2026 upto 11
                  pm.
                </b>
              </p>
              <p>
                <b>
                  The link for registration form will be available at:
                </b>
              </p>
              <a
                href="https://entab.online/ncsraj"
                target="_blank"
                rel="noopener noreferrer"
                className="admission-register-btn"
              >
                Open Registration Form
                <span aria-hidden="true">↗</span>
              </a>
              <p>
                <b>
                  (Note : The link will be available at above url from 23rd
                  November 2026 at 10 am)
                </b>
              </p>

              <p>
                <b>Eligibility:</b> The age of the child seeking admission to
                Nursery Class 2027-28 should be between 3 years and 4 years as
                on 01 June, 2027. If your child is NOT within the age limit
                specified, she will not be eligible for admission.
              </p>
            </div>
            <div className="col-md-4">
              <p>Procedure to fill the online registration form: -</p>
              <a
                data-magnify="gallery"
                data-src=""
                data-group="a"
                href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/admission-registration.png"
              >
                <LazyLoad>
                  
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/admission-registration.png"
                    class="img-fluid admissionimg"
                    alt=" Children's Convent School Rajkot"
                  />
                </LazyLoad>
              </a>
              <p>
                For more details: Read the guideline attached in Latest News/
                Highlights section.
              </p>
            </div>
            {/* <div className = "col-12">
              <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/admission_procedure.jpeg" style={{height:"700px",margin:"auto",display:"block"}}/>
            </div> */}
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};
export default AdmissionProcedure;
